import { type Locale } from "./constants.js";

import enCA from "./locales/en-CA/commands.json" with { type: "json" };
import enUS from "./locales/en-US/commands.json" with { type: "json" };
import frCA from "./locales/fr-CA/commands.json" with { type: "json" };
import esMX from "./locales/es-MX/commands.json" with { type: "json" };
import jaJP from "./locales/ja-JP/commands.json" with { type: "json" };
import ptPT from "./locales/pt-PT/commands.json" with { type: "json" };
import paIN from "./locales/pa-IN/commands.json" with { type: "json" };

export const COMMAND_INTENTS = ["leave", "list", "language", "help"] as const;
export type CommandIntent = (typeof COMMAND_INTENTS)[number];

/** Accepted keywords per intent. Element 0 is the form shown to growers in a reply. */
export type CommandsCatalog = Record<CommandIntent, string[]>;

/**
 * Per-locale command vocabulary. Unlike the copy catalogs these are matched, never rendered, so they
 * carry no fallback: an absent locale must fail a test rather than silently answer in English.
 */
export const commandCatalogs: Record<Locale, CommandsCatalog> = {
    "en-CA": enCA as CommandsCatalog,
    "en-US": enUS as CommandsCatalog,
    "fr-CA": frCA as CommandsCatalog,
    "es-MX": esMX as CommandsCatalog,
    "ja-JP": jaJP as CommandsCatalog,
    "pt-PT": ptPT as CommandsCatalog,
    "pa-IN": paIN as CommandsCatalog,
};
